<template>
  <section class="ProductReviews" v-if="productReviewsAverage.count > 0">
    <div class="Product-menuTarget" data-links="avis produits" id="reviews"></div>
    <div class="container-small noBorder">
      <!-- HEAD -->
      <div
        class="ProductReview-head Separator-title"
        @click="isMobile ? (hiddenEllement = !hiddenEllement) : false"
      >
        <div class="ProductReview-title">
          Avis <span>produits</span> <small>({{ productReviewsAverage.count }})</small>
        </div>

        <div class="ProductReview-headRating rating">
          <StarRating
            :rating="Number(productReviewsAverage.rate)"
            v-bind:increment="0.1"
            v-bind:read-only="true"
            v-bind:max-rating="5"
            v-bind:star-size="14"
          ></StarRating>
        </div>

        <div class="ProductReview-average">
          <span>{{ Math.ceil(parseFloat(productReviewsAverage.rate) * 10) / 10 }}</span>
          <p class="desktopOnly">Note moyenne</p>
        </div>

        <svg
          v-svg
          symbol="Arrow_Right"
          size="0 0 18 18"
          role="presentation"
          class="icon--inline Separator-chevron mobileOnly"
          :class="{ isOpen: !hiddenEllement }"
          @click.stop="hiddenEllement = !hiddenEllement"
        ></svg>
      </div>

      <transition name="slide-fade">
        <!-- CONTENT -->
        <div class="ProductReview-content" v-if="!hiddenEllement">
          <ul v-if="reviews.length > 0">
            <!-- reviews -->
            <ProductReviewCard
              :review="review"
              v-for="(review, key) in reviews"
              :key="key"
            ></ProductReviewCard>

            <!-- see More -->
            <div class="ProductReview-seeMore">
              <li v-if="collapsed === true && productReviews.length > 3">
                <button type="button" @click="collapsed = !collapsed">
                  Voir les {{ productReviewsAverage.count }} avis clients
                </button>
              </li>
            </div>

            <!-- reviews Remains -->
            <transition name="slide-fade">
              <div
                class="ProductReview-remains"
                v-if="collapsed === false && remainsReviews.length > 0"
              >
                <ProductReviewCard
                  :review="review"
                  v-for="(review, key) in remainsReviews"
                  :key="key"
                ></ProductReviewCard>
              </div>
            </transition>
            <!-- see Less -->
            <div class="ProductReview-seeMore">
              <li v-if="collapsed === false && productReviews.length > 3">
                <button type="button" @click="collapsed = !collapsed">
                  Voir moins
                </button>
              </li>
            </div>
          </ul>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import StarRating from "vue-star-rating";
import ProductReviewCard from "@/includes/Product/ProductReviewCard/ProductReviewCard.vue";
import "@/components/Product/ProductReviews/ProductReviews.scss";

export default {
  name: "ProductReviews",
  components: {
    StarRating,
    ProductReviewCard,
  },
  data () {
    return {
      collapsed: true,
      hiddenEllement: false,
    };
  },

  mounted () {
    if (this.productReviews && window.innerWidth < 1100) {
      this.isMobile = true;
      this.hiddenEllement = true;
    }
  },

  computed: {
    ...mapGetters({
      productReviews: "getProductReviews",
      productReviewsAverage: "getProductReviewsAverage",
    }),

    reviews () {
      return this.productReviews.filter((i, k) => (k <= 2 ? i : null));
    },

    remainsReviews () {
      return this.productReviews.filter((i, k) => (k > 2 ? i : null));
    },
  },
};
</script>
